export default "__VITE_ASSET__c7bf7ed0__"